import { render, staticRenderFns } from "./proposal_carry_part.vue?vue&type=template&id=a8193590&scoped=true"
import script from "./proposal_carry_part.vue?vue&type=script&lang=js"
export * from "./proposal_carry_part.vue?vue&type=script&lang=js"
import style0 from "./proposal_carry_part.vue?vue&type=style&index=0&id=a8193590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8193590",
  null
  
)

export default component.exports